import React from 'react';
import { AlertOctagon } from 'lucide-react';
import { useAirtableOutage } from '../hooks/useAirtableOutage';

export default function AirtableOutageBanner() {
  const isOutage = useAirtableOutage();

  if (!isOutage) return null;

  return (
    <div
      role="alert"
      className="bg-red-600 text-white px-4 py-3 flex flex-wrap items-center justify-center gap-2 text-sm"
    >
      <AlertOctagon className="h-5 w-5 flex-shrink-0" />
      <span>
        Airtable is experiencing service issues. Some features may be unavailable.
      </span>
      <a
        href="https://status.airtable.com"
        target="_blank"
        rel="noopener noreferrer"
        className="underline font-medium hover:text-red-100"
      >
        Check Airtable Status
      </a>
    </div>
  );
}
